import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Label, Modal, ModalBody, ModalHeader, Row, Input } from 'reactstrap';
import CreatableSelect from 'react-select/creatable';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createOrUpdateTag, fetchAllKeyNames } from "../../store/service/actions";

const AddTagModal = ({ isOpenn, togglee, serviceId, onTagAdded }) => {
  const dispatch = useDispatch();
  const availableKeys = useSelector((state) => state.Service.tagKeys || []);
  const [availableKeyOptions, setAvailableKeyOptions] = useState([]);
  useEffect(() => {
    if (isOpenn) {
      dispatch(fetchAllKeyNames());
    }
  }, [dispatch, isOpenn]);

  useEffect(() => {
    setAvailableKeyOptions(
      availableKeys.map((key) => ({
        label: key.key_name,
        value: key.id,
      }))
    );
  }, [availableKeys]);

  const validation = useFormik({
    enableReinitialize: true,
    validationSchema: Yup.object({
      key_name: Yup.string().required('Key is required'),
      value: Yup.string().required('Value is required'),
    }),
    initialValues: {
      key_name: '',
      value: '',
    },
    onSubmit: async (values) => {
      const payload = {
        service_id: serviceId,
        key_name: values.key_name,
        value: values.value,
      };

      try {
       dispatch(createOrUpdateTag(payload));
        validation.resetForm();
      } catch (error) {
        console.error("Failed to create or update tag:", error);
      }
      togglee();
    },
  });
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#382b42',
      borderRadius: 0,
      color: 'white',
      borderColor: state.isFocused ? 'white' : 'rgba(255, 255, 255, 0.7)',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: 'white',
    }),
    menu: (provided) => ({
      ...provided,
      background: '#473753',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',
    }),
    input: (provided) => ({
      ...provided,
      color: 'white',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'rgba(255, 255, 255, 0.7)',
    }),
  };

  return (
    <Modal isOpen={isOpenn} toggle={togglee} centered>
      <ModalHeader toggle={togglee}>Tag Service</ModalHeader>
      <ModalBody>
        <Form
          className='form-horizontal'
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <Row>
            <Col>
              <div className="mb-3">
                <Label htmlFor="key_name">Key Name</Label>
                <CreatableSelect
                  id="key_name"
                  name="key_name"
                  onBlur={validation.handleBlur}
                  value={availableKeyOptions.find(
                    (option) => option.label === validation.values.key_name
                  )}
                  placeholder="Select or Add Key"
                  style={{ color: 'white' }}
                  onChange={(selectedOption) => {
                    validation.setFieldValue('key_name', selectedOption ? selectedOption.label : '');
                  }}
                  options={availableKeyOptions}
                  className="select2-selection col-form-label"
                  styles={customStyles}
                />
                {validation.errors.key_name && validation.touched.key_name && (
                  <div className="text-danger">{validation.errors.key_name}</div>
                )}
              </div>

              <div className="mb-3">
                <Label htmlFor="key_value">Key Value</Label>
                <Input
                  name="value"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.value}
                />
                {validation.errors.value && validation.touched.value && (
                  <div className="text-danger">{validation.errors.value}</div>
                )}
              </div>
              <div className="text-end">
                <button type="submit" className="btn btn-primary">
                  Create Tag
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

AddTagModal.propTypes = {
  togglee: PropTypes.func.isRequired,
  isOpenn: PropTypes.bool.isRequired,
  serviceId: PropTypes.any.isRequired,
};

export default AddTagModal;

